module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageAgency.elements) ? _c('div', {
    staticClass: "landing-agency"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageAgency.elements,
      "heroHome": true
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-description col-xs-12 no-gutters",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "copy col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-text"
  }, [(_vm.pageAgency.elements.description_title) ? _c('h3', [_vm._v(_vm._s(_vm.pageAgency.elements.description_title.value))]) : _vm._e(), _vm._v(" "), (_vm.pageAgency.elements.description_text) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageAgency.elements.description_text.value)
    }
  }, [_vm._v(_vm._s(_vm.pageAgency.elements.description_title.value))]) : _vm._e()])]), _vm._v(" "), (_vm.pageAgency.elements.detail_image_background) ? _c('div', {
    staticClass: "detail col-xs-12 col-md-6",
    style: (_vm.setBackgroundImage(_vm.pageAgency.elements.detail_image_background.value[0].url))
  }, [_c('div', {
    staticClass: "content-circles"
  }, [_c('div', {
    staticClass: "inner text-center"
  }, [(_vm.pageAgency.elements.capitalized_billlings.value) ? _c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "agency-circle"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pageAgency.elements.capitalized_billlings.value) + " "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fix-center-flex"
  }, [_vm._v("million")])])]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("CAPITALIZED BILLINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "inner text-center"
  }, [(_vm.pageAgency.elements.employees.value) ? _c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "agency-circle"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pageAgency.elements.employees.value))])]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("EMPLOYEES")])]), _vm._v(" "), _c('div', {
    staticClass: "inner text-center"
  }, [(_vm.pageAgency.elements.dogs.value) ? _c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "agency-circle"
  }, [_c('h3', [_vm._v(_vm._s(_vm.pageAgency.elements.dogs.value))])]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("DOGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.pageAgency.elements.awards_logos) ? _c('section', {
    staticClass: "content-awards text-center"
  }, [_c('h2', [_vm._v("Awards")]), _vm._v(" "), (_vm.pageAgency.elements.awards_description) ? _c('p', {
    staticClass: "container"
  }, [_vm._v(_vm._s(_vm.pageAgency.elements.awards_description.value))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "awards-container container"
  }, _vm._l((_vm.pageAgency.elements.awards_logos.value), function(award) {
    return _c('div', {
      staticClass: "award"
    }, [_c('img', {
      attrs: {
        "src": award.url,
        "alt": award.name
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.leaders.length) ? _c('section', {
    staticClass: "container-leaders"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "text-center container"
  }, [_c('h2', [_vm._v("Executive Leadership Team")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pageAgency.elements.excecutive_leadership_description.value))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.closeLeader),
      expression: "closeLeader"
    }],
    staticClass: "boxes-leaders"
  }, [_vm._l((_vm.leaders), function(box, index) {
    return _c('div', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ({
          el: '#c' + index,
          offset: -10
        }),
        expression: "{el:'#c'+index,offset:-10}"
      }],
      staticClass: "box-leader",
      class: {
        active: _vm.activeLeaderid == index
      },
      style: (_vm.putInOrder(index)),
      attrs: {
        "id": 'c' + index
      },
      on: {
        "click": function($event) {
          return _vm.selectLeader(box, index)
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "bio-hover"
    }, [_c('span', {
      staticClass: "bio-hover-name"
    }, [_vm._v(_vm._s(box.name.value))]), _vm._v(" "), _c('span', {
      staticClass: "bio-hover-role"
    }, [_vm._v(_vm._s(box.position.value))])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": box.image.value[0].url,
        "alt": box.image.value[0].name
      }
    })])])
  }), _vm._v(" "), (_vm.openLeader) ? _c('div', {
    staticClass: "box-bio",
    style: (_vm.orderBioLeaders()),
    attrs: {
      "id": "leaders-bio"
    }
  }, [_c('span', {
    staticClass: "grey-arrow",
    style: (_vm.arrowLeaderPosition())
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.closeLeader()
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bio-left"
  }, [_c('div', {
    staticClass: "copy"
  }, [(_vm.selectedLeader.name.value) ? _c('h4', [_vm._v(_vm._s(_vm.selectedLeader.name.value))]) : _vm._e(), _vm._v(" "), (_vm.selectedLeader.position.value) ? _c('h5', [_vm._v(_vm._s(_vm.selectedLeader.position.value))]) : _vm._e(), _vm._v(" "), (_vm.selectedLeader.email_address.value) ? _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.selectedLeader.email_address.value
    }
  }, [_vm._v(_vm._s(_vm.selectedLeader.email_address.value))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "social-icons"
  }, [(_vm.selectedLeader.facebook.value) ? _c('a', {
    staticClass: "social-icon",
    attrs: {
      "href": _vm.selectedLeader.facebook.value,
      "target": "_blank",
      "title": "Go to Marcus Thomas's Facebook"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedLeader.twitter.value) ? _c('a', {
    staticClass: "social-icon",
    attrs: {
      "href": _vm.selectedLeader.twitter.value,
      "target": "_blank",
      "title": "Go to Marcus Thomas's Twitter"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedLeader.linkedin.value) ? _c('a', {
    staticClass: "social-icon",
    attrs: {
      "href": _vm.selectedLeader.linkedin.value,
      "target": "_blank",
      "title": "Go to Marcus Thomas's Linked In"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-right"
  }, [(_vm.selectedLeader.bio.value) ? _c('p', [_vm._v(_vm._s(_vm.selectedLeader.bio.value))]) : _vm._e()])])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles container-fluid"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v("Insights, commentary and news")]), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.relatedArticles,
      "isHome": true,
      "boxlimit": 4,
      "pathRoute": '/words',
      "showViewAll": true,
      "showCategory": true
    }
  })], 1)]), _vm._v(" "), (_vm.quote.elements) ? _c('section', {
    staticClass: "content-quote container-fluid col-xs-12"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "quote-text text-center"
  }, [_vm._v("\n\t\t\t\t\"" + _vm._s(_vm.quote.elements.quote_text.value) + "\"\n\t\t\t\t"), _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.quote.elements.author.value) + " ")])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19ef96a1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Agency.vue
// module id = 1504
// module chunks = 0